import React, { useEffect, useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { redirectToPages } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader
} from "../../../../../../../_metronic/_partials/controls";
import { TeachersFilter } from "./teachers-filter/TeachersFilter";
import { TeachersTable } from "./teachers-table/TeachersTable";
import { useTeachersUIContext } from "./TeachersUIContext";

export function TeachersCard({
  setReceipentIds
}) {
  // Teachers Card UI Context
  const teachersUIContext = useTeachersUIContext();
  const teachersUIProps = useMemo(() => {
    return {
      ids: teachersUIContext.ids
    };
  }, [teachersUIContext]);

  // Getting curret state of Teachers from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );  
  const { isSuccess, type } = currentState;
    
  useEffect(() => {
    setReceipentIds(teachersUIProps.ids);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teachersUIProps.ids]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const title = <>Öğretmen Listesi{teachersUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{teachersUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title} />
      <CardBody>
        <TeachersFilter />
        <TeachersTable />
      </CardBody>
    </Card>
  );
}